import { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import FilterList from './filter';
import type { PathFilterItem } from './filter';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default function Collections() {
  const [collections, setCollections] = useState<PathFilterItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCollections() {
      try {
        // Récupérer toutes les catégories actives
        const { data, error } = await supabase
          .from('kiosk_categories')
          .select('id, name')
          .eq('is_active', true)
          .order('name', { ascending: true });

        if (error) throw error;

        // Créer la liste avec "All" en premier
        const collectionsList: PathFilterItem[] = [
          { title: 'All', path: '/search' }
        ];

        if (data) {
          data.forEach((category) => {
            collectionsList.push({
              title: category.name,
              path: `/search/${category.id}`
            });
          });
        }

        setCollections(collectionsList);
      } catch (error) {
        console.error('Error loading collections:', error);
        // Fallback avec catégories hardcodées si la requête échoue
        setCollections([
          { title: 'All', path: '/search' },
          { title: 'Bags', path: '/search/bags' },
          { title: 'Drinkware', path: '/search/drinkware' },
          { title: 'Electronics', path: '/search/electronics' },
          { title: 'Footware', path: '/search/footware' },
          { title: 'Headwear', path: '/search/headwear' },
          { title: 'Hoodies', path: '/search/hoodies' },
          { title: 'Jackets', path: '/search/jackets' },
          { title: 'Kids', path: '/search/kids' },
          { title: 'Pets', path: '/search/pets' },
          { title: 'Shirts', path: '/search/shirts' },
          { title: 'Stickers', path: '/search/stickers' }
        ]);
      } finally {
        setLoading(false);
      }
    }
    loadCollections();
  }, []);

  if (loading) {
  return (
      <div className="mb-3 h-4 w-5/6 animate-pulse rounded-sm bg-neutral-400 dark:bg-neutral-700" />
    );
  }

  return <FilterList list={collections} title="Collections" />;
}
